/* eslint-disable @typescript-eslint/no-explicit-any */
import apiEndpoints from '@src/lib/apiEndpoints';

import apiRequest from './api';

export const createBooking = (bookingData: {
  user: string;
  room: string;
  startTime: string;
  endTime: string;
  bookingDate: string;
  location: string;
  status: string;
  orgID: string;
  services?: {
    name: string;
    type?: string[];
  }[];
}): Promise<any> => {
  const { orgID, ...rest } = bookingData;
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.BOOKINGS}`,
    data: rest,
    config: { params: { orgID } },
  });
};

export const getBookings = (
  filters: {
    startDate?: string;
    endDate?: string;
  } = {},
  orgID: string
): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.BOOKINGS}`,
    config: { params: { ...filters, orgID } },
  });
};

export const getBookingById = (bookingId: string, orgID: string): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.BOOKINGS}/${bookingId}`,
    config: { params: { orgID } },
  });
};

export const getBookingsByIds = (bookingId: string, orgID: string): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.BOOKINGS_BY_IDS}/${bookingId}`,
    config: { params: { orgID } },
  });
};

export const updateBooking = (
  bookingId: string,
  updateData: {
    user?: string;
    room?: string;
    startTime?: string;
    endTime?: string;
    bookingDate?: string;
    location?: string;
    status?: string;
  },
  orgID: string
): Promise<any> => {
  return apiRequest({
    method: 'PUT',
    url: `${apiEndpoints.BOOKINGS}/${bookingId}`,
    data: updateData,
    config: { params: { orgID } },
  });
};

export const deleteBooking = (bookingId: string, orgID: string): Promise<any> => {
  return apiRequest({
    method: 'DELETE',
    url: `${apiEndpoints.BOOKINGS}/${bookingId}`,
    config: { params: { orgID } },
  });
};

export const getBookingToken = ({ phoneNumber }: { phoneNumber: string }): Promise<any> => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.GET_BOOKING_TOKEN}`,
    data: { phoneNumber },
  });
};

export const getUserBooking = (token: string, orgID: string): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.USER_BOOKING}`,
    config: { headers: { Authorization: `Bearer ${token}` }, params: { orgID } },
  });
};
